import React, { useState } from 'react'
import { useProfileRequest } from '../../Hooks/Features/Profile/useProfileRequest'
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid';
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCommon } from '../../Hooks/Common/useCommon';

const ProfileRequestList = () => {

    const { options, rowData, columns, filterValues, setFilterValues, viewPopup, setViewPopup, handleRequest, getRequestList, loader, tagRef } = useProfileRequest();
    const { checkPermission } = useCommon();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

    return (
        <div ref={() => checkPermission("help desk", tagRef)}>
            <div ref={tagRef} id='{"data": "profile_request_tab"}' >
                <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2 mb-3 px-3">
                    <div className="d-flex align-items-center gap-2 flex-grow-1">
                        <h5 className="mb-0">Profile Request</h5>
                    </div>
                    <div className="d-flex justify-content-end align-items-center gap-2">
                        <button className="sk-btn sk-btn-primary" onClick={() => getRequestList()} title="Refresh">
                            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                        </button>
                        <button className="sk-btn sk-btn-primary" onClick={() => setShowFiltersDrawer(true)} title="Filters">
                            <FontAwesomeIcon icon="fa-solid fa-filter" />
                        </button>
                    </div>
                </div>

                <div className="px-3">
                    <CommonGrid columns={columns} data={rowData} expandAll={true} rowHeight={30} loader={loader} />
                </div>

                <CommanDialog
                    visible={viewPopup?.show}
                    message="Are you sure you want to approve this request?"
                    handleClose={() => { setViewPopup({ show: false }) }}
                    handleFun={() => {
                        handleRequest(viewPopup?.newValue, viewPopup?.id)
                    }}
                />

                {/* Right Panel Filters Drawer */}
                <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                    <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                        <div className="sk-drawer-header">
                            <h5 className="sk-drawer-title">Filters</h5>
                            <div className="d-flex align-items-center gap-2">
                                <button className="sk-drawer-clear-btn" onClick={() => {
                                    if (options?.statusOptions?.length > 0) {
                                        setFilterValues({ status: options.statusOptions[0] });
                                    }
                                }}>Clear All</button>
                                <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                    <FontAwesomeIcon icon="fa-solid fa-xmark" />
                                </button>
                            </div>
                        </div>
                        <div className="sk-drawer-body">
                            <div className='d-flex flex-column gap-4'>
                                {/* Status Filter */}
                                <div className="sk-drawer-filter-group">
                                    <div className="task-list-filter-label">Status</div>
                                    <div className='sk-segment-control mb-3'>
                                        {options?.statusOptions?.map((item) => (
                                            <button
                                                key={item.request_status_id}
                                                type="button"
                                                className={`sk-segment-btn ${filterValues.status?.request_status_id === item.request_status_id ? 'active' : ''}`}
                                                onClick={() => {
                                                    setFilterValues({ status: item });
                                                }}
                                            >
                                                {item.request_status_name}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sk-drawer-footer">
                            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                                getRequestList();
                                setShowFiltersDrawer(false);
                            }}>Apply Filters</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfileRequestList;
